module.exports = __webpack_public_path__ + "img/Portable.b4523853.jpg";